import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import Layout from './../../../hoc/Layout/Layout';
import Header from './../../../containers/Navigation/Header/Header';
import Footer from './../../../containers/Navigation/Footer/Footer';
import ArticlesListRenderer from './../../../components/ArticlesList/ArticlesListRenderer';

import TinyJellyShape from './../../../containers/UI/Common/JellyShape/TinyJellyShape';
import ClickableIcon from './../../../containers/UI/ClickableIcon/ClickableIcon';
import ChatButton from './../../UI/Common/ChatButton/ChatButton';
import Avatar from './../../../containers/UI/Avatar/Avatar';
import Image from './../../../containers/UI/Image/Image';

// config
import * as config from './../../../conf/config';

//-- Utils
import { pushHeaderTitle } from '../../../utils/dom/helper';
import { pushPageView } from '../../../utils/tracking/customGtm';

// assets
import BurgerMenu from './../../../assets/images/icons/burger.svg';
import ThemeBtnArrow from './../../../assets/images/icons/retour_thematique.svg';
import SubscribeImg from './../../../assets/images/subscribe.png'; 

class ThematicArticleList extends Component {

  state = {
    thematicName: '',
  }

  /*componentWillMount() {

      // get the thematic slug based on the current routing params
      let currentThematicName = '';
      if(this.props.match){ 
          if(this.props.match.path.match('/thematic/')){ 
              currentThematicName = this.props.match.params.name;
          }
      }

      // Thematic
      let thematicName = '';
      if(this.props.availableThematics.length>0){
          for (const thematicIndex in this.props.availableThematics) {  
              const currentThematic = this.props.availableThematics[thematicIndex];    
              if(currentThematic.slug===currentThematicName){
                  thematicName = currentThematic.name;
                  break;
              }
          }   
      }
      this.setState({ thematicName : thematicName})
  }*/

  componentDidMount() {
    //-- Update title
    if (this.state.thematicName !== '') {
      pushHeaderTitle(`Thématique : ${this.state.thematicName}`);
    }
    //-- Push GTM page view
    pushPageView();


    this.handleResize();
    window.addEventListener('resize', this.handleResize)
  }

  componentDidUpdate(prevProps, prevState) {
    if (typeof this.state.thematicName !== 'undefined' && this.state.thematicName !== prevState.thematicName) {
      //-- Update title
      pushHeaderTitle(`Thématique : ${this.state.thematicName}`);

      //-- Push GTM page view
      pushPageView();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  };

  static getDerivedStateFromProps(nextProps, prevState) //similar to component will update. this function will be call before the render
  {

    // get the thematic slug based on the current routing params
    let currentThematicName = '';
    if (nextProps.match) {
      if (nextProps.match.path.match('/thematic/')) {
        currentThematicName = nextProps.match.params.name;
      }
    }

    // Thematic
    let thematicName = '';
    if (nextProps.availableThematics.length > 0) {
      for (const thematicIndex in nextProps.availableThematics) {
        const currentThematic = nextProps.availableThematics[thematicIndex];
        if (currentThematic.slug === currentThematicName) {
          thematicName = currentThematic.name;
          break;
        }
      }
    }
    return {
      thematicName
    }
  }

  splitThematicLetters = (title) => {
    let charactersOutput = '';
    for (let i = 0; i < title.length; i++) {
      charactersOutput += "<span>" + title.charAt(i) + "</span>";
    }
    return charactersOutput;
  }

  handleAvatarClick = () => {
    const {
      onGoToProfile
    } = this.props;
    onGoToProfile();
  }

  handleResize = () => {
    let currentWidth = window.innerWidth;
    let displayMode = '';
    if (config.responsiveBreakpointConfig) {
      for (let i = 0; i < config.responsiveBreakpointConfig.length; i++) {
        const breakPoints = config.responsiveBreakpointConfig[i];
        if (breakPoints.hasOwnProperty('maxWidth')) {
          if (currentWidth <= breakPoints.maxWidth) {
            displayMode = breakPoints.profile.toUpperCase();
            break;
          }
        }
      }
    }

    this.setState({
      containerWidth: window.innerWidth,
      displayMode: displayMode
    });
  }

  onClickSubscribeHandler = (event) => {
    event.preventDefault();
    window.open(config.linkSubscribe, '_blank');
  }

  render() {
    const {
      uid,
      user,
      points
    } = this.props;

    return (
      <Layout layoutClass="thematic-page">
        <Header classes='thematic-header'>
          <ClickableIcon name="backBtn" class="icon-back-btn" iconPath={ThemeBtnArrow} action={this.props.onBackArticleClicked} />
          <TinyJellyShape color="#49d1e5" />
          <div className="thematic-name-container" dangerouslySetInnerHTML={{__html: this.splitThematicLetters(this.state.thematicName)}}></div>
        </Header>
        <main>
        <div className="thematic-article-list">
          <div className="spacer"></div>
          <ArticlesListRenderer route={this.props.match} isGridDisplay={this.state.displayMode==='DESKTOP'?true:false}/>
          <div className="spacer"></div>
        </div>
        </main>
        <Footer classes='thematic-footer'>
          <ClickableIcon name="toggleMenu" class="icon-menu" iconPath={BurgerMenu} />
          <span >
          { this.props.isUserSignedIn?
            <Avatar avatarName={user.avatar} userName={user.username} isEditable={false} imgClick={this.handleAvatarClick} badgeUser={points.totalPoints} />
            :
            <div className="avatar-container subscribe" onClick={this.onClickSubscribeHandler}>
              <Image 
                  isResponsive='true'
                  imgPath={SubscribeImg}
                  imgName="discovery-avatar"
              />
            </div>
          }
          </span>
          <ChatButton roomName={`${uid}_ask`} metaData={this.props.user.username} comment={false} />
        </Footer>
      </Layout>
    )
  }

}

const mapStateToProps = state => {
  return {
    user: state.user,
    uid: state.auth.uid,
    isUserSignedIn: state.auth.isUserSignedIn,
    points: state.points,
    availableThematics: state.thematics.thematics,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    onBackArticleClicked: () => dispatch(push('/')),
    onGoToProfile: () => dispatch(push('/account/profile'))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ThematicArticleList);


// WEBPACK FOOTER //
// ./src/components/Article/Thematic/ThematicArticleList.js